// src/config/auth.constants.ts
export const AUTH_CONSTANTS = {
  TOKEN_MIN_VALIDITY_SECONDS: 30,
  TOKEN_BACKGROUND_REFRESH_SECONDS: 70,
  TOKEN_REFRESH_INTERVAL_MS: 60000,
  TOKEN_MIN_VALIDITY_RETRY: 5,
} as const

/**
 * Customer Care section (SuperQi identity correction, bulk merge, merge all).
 * Switched off after the production duplicate-accounts merge; flip to true to
 * show the menu and routes again.
 */
export const CUSTOMER_CARE_ENABLED = false
